import { useHighlightsLocalStorage } from "components/Graph/hooks/useHighlightsLocalStorage.ts";
import { GraphId } from "components/Graph/types.ts";
import { useTable } from "components/UI/Table/hooks/useTable.ts";
import { useState } from "react";
import { TableId } from "types/models.ts";

export const useReport = (graphId: GraphId, defaultSortBy: string, tableId: TableId) => {
    const lc_highlights = useHighlightsLocalStorage().get(graphId);

    const [sortBy, setSortBy] = useState(
        () => Object.entries(lc_highlights).find(([, value]) => value?.state === "active")?.[0] || defaultSortBy
    );

    const { saveSort } = useTable(tableId);

    const handleSetSortBy = (key: string) => {
        saveSort(`-${key}`);
        setSortBy(key);
    };

    return { setSortBy: handleSetSortBy, sortBy };
};
